import { render } from "./DateHeader.vue?vue&type=template&id=ebb3493c&scoped=true"
import script from "./DateHeader.vue?vue&type=script&lang=js"
export * from "./DateHeader.vue?vue&type=script&lang=js"

import "./DateHeader.vue?vue&type=style&index=0&id=ebb3493c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb3493c"]])

export default __exports__